import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, isLoading } = useAuth();
  const [tokenStored, setTokenStored] = useState(false);

  useEffect(() => {
    const token = searchParams.get('token');

    if (token && !tokenStored) {
      // Store token
      localStorage.setItem('token', token);
      setTokenStored(true);

      // Trigger a full page reload to ensure AuthContext picks up the new token
      // This is the most reliable way to ensure the token is picked up
      window.location.href = '/dashboard';
    } else if (!token && !user) {
      // No token and no user, redirect to login
      navigate('/login');
    }
  }, [searchParams, navigate, user, tokenStored]);

  // If we have a user (token was already processed), redirect based on role
  useEffect(() => {
    if (user && !isLoading) {
      if (user.role === 'platform_admin') {
        navigate('/admin/console', { replace: true });
      } else if (user.role === 'gym_manager' || user.role === 'chain_owner') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/dashboard', { replace: true });
      }
    }
  }, [user, isLoading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 via-purple-50 to-magenta-50">
      <div className="text-center">
        <LoadingSpinner size="large" />
        <p className="mt-4 text-lg font-semibold text-slate-700">Completing sign-in...</p>
        <p className="mt-2 text-base font-medium text-slate-600">You'll be redirected shortly</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
